import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Meeting from "@/services/meeting";
import { RegisterMeeting } from "@/dtos/Meeting.dto";

/**
 * Composable for registering a new meeting
 */
export function useRegisterMeeting() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (meeting: RegisterMeeting) => {
      const result = await Meeting.registerMeeting(meeting);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to register meeting");
      }
      const data = result.data?.data ?? result.data;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["meetings"] });
    },
  });
}
